import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { useInView } from '@/hooks/useInView';

const categorySlugMap: Record<string, string> = {
  '明星八卦': 'star-gossip',
  '综艺热点': 'variety-show',
  '影视追踪': 'film-tv',
  '社会热点': 'society',
  '音乐圈': 'music-circle',
};

export default function FeatureGrid() {
  const [ref, inView] = useInView(0.1);
  const top4 = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 4);
  const mainArticle = top4[0];
  const sideArticles = top4.slice(1, 4);

  return (
    <section ref={ref} className={`py-14 md:py-20 px-4 md:px-6 bg-background-100 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
      <div className="text-center mb-10 md:mb-14">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary-900">
          今日瓜王争霸
        </h2>
        <p className="mt-3 text-foreground-500 text-sm md:text-base">
          热度最高的话题都在这里，谁是今天的<span className="text-secondary-600 font-semibold">瓜王</span>？
        </p>
      </div>

      <div className="flex flex-col lg:flex-row gap-5 max-w-6xl mx-auto">
        <Link
          to={`/article/${mainArticle.slug}`}
          className="lg:w-[55%] group relative rounded-2xl overflow-hidden h-[320px] md:h-[420px] cursor-pointer"
        >
          <img
            src={mainArticle.coverImage}
            alt={mainArticle.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-900/80 via-primary-900/20 to-transparent"></div>
          <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
            <span className="inline-block px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-semibold mb-3 whitespace-nowrap">
              🔥 热度 {mainArticle.heat}
            </span>
            <h3 className="text-lg md:text-xl font-heading font-bold text-white leading-tight mb-2">
              {mainArticle.title}
            </h3>
            <p className="text-foreground-200 text-xs md:text-sm line-clamp-2">
              {mainArticle.excerpt}
            </p>
          </div>
        </Link>

        <div className="lg:w-[45%] flex flex-col gap-5">
          {sideArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group relative rounded-2xl overflow-hidden h-[100px] md:h-[130px] cursor-pointer ${
                idx === 0 ? 'bg-secondary-100/60' : idx === 1 ? 'bg-accent-100/50' : 'bg-background-200/70'
              }`}
            >
              <div className="flex h-full">
                <div className="w-28 md:w-40 flex-shrink-0 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex-1 p-4 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs text-accent-500 font-semibold whitespace-nowrap">
                      TOP {article.rank}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap" onClick={(e) => e.stopPropagation()}>
                      <Link
                        to={`/category/${categorySlugMap[article.category] || 'star-gossip'}`}
                        className="hover:text-accent-500 transition-colors"
                      >
                        {article.category}
                      </Link>
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 leading-tight line-clamp-1 group-hover:text-accent-600 transition-colors">
                    {article.title}
                  </h3>
                  <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                    <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(1)}万阅读
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
